import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = ['select']

  connect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      plugins: ['remove_button', 'checkbox_options'],
      searchField: ['value', 'text'],
      placeholder: 'Search signs & symptoms...',
      closeAfterSelect: false
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
